import React, { useContext } from 'react';
import { Box, Snackbar, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { NotificationContext } from './context/Notification.js';

const Notification = () => {
  const { notification, setNotification } = useContext(NotificationContext);

  const handleClose = () => {
    setNotification({ open: false, message: null });
  };

  return (
    <Box sx={{ width: 500 }}>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={notification.open}
        autoHideDuration={10000}
        onClose={handleClose}
        message={notification.message}
        action={
          <React.Fragment>
            <IconButton
              aria-label="close"
              color="inherit"
              sx={{ p: 0.5 }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </React.Fragment>
        }
      />
    </Box>
  )
}

export default Notification;